export default __webpack_public_path__ + "static/flask_io_dash-a22af9078eb74d032288c68cdc0869a2.png";